import { FC } from 'react'

import { LoadingSpinner } from '../../../../@paco/components'

import { Log, LoketData } from '../../../../models'
import LoketDataCard from '../../components/LoketDataCard/LoketDataCard'
import LoketLogsCard from '../../components/LoketLogsCard/LoketLogsCard'

import './Synchronizations.scss'

interface SynchronizationsProps {
    isLoading: boolean;
    loketData: LoketData | null;
    logs: Log[];
    onNonCoupledEmployeesButtonClick: () => void;
}

const Synchronizations: FC<SynchronizationsProps> = ({
    isLoading,
    loketData,
    logs,
    onNonCoupledEmployeesButtonClick,
}) => (
    <div className="synchronizations page">
        <LoketDataCard
            className="synchronizations__card"
            loketData={loketData}
            onNonCoupledEmployeesButtonClick={onNonCoupledEmployeesButtonClick}
        />
        <LoketLogsCard
            className="synchronizations__card-logs"
            logs={logs}
        />
        {isLoading && <LoadingSpinner />}
    </div>
)

export default Synchronizations
